import Icon from '../components/Icon.vue'

Icon.register({
  medal: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M223.8 130.8c-42 6.6-79.8 25.6-109.6 53.4l-111.3-159c-7.4-10.6 0.2-25.2 13.1-25.2h111.1c10 0 22.3 7 27.4 15.5zM496 0c13 0 20.5 14.6 13.1 25.2l-111.3 158.9c-29.7-27.8-67.5-46.8-109.6-53.4l69.1-115.2c5.8-9.6 16.2-15.5 27.4-15.5h111.1zM256 160c97.2 0 176 78.8 176 176s-78.8 176-176 176-176-78.8-176-176 78.8-176 176-176zM348.5 317.3c6.8-6.6 3.1-18.2-6.3-19.6l-52.4-7.6-23.4-47.5c-2.1-4.3-6.2-6.4-10.3-6.4-4.1 0-8.2 2.1-10.3 6.4l-23.4 47.5-52.4 7.6c-9.4 1.4-13.2 13-6.3 19.6l37.9 37-9 52.2c-1.6 9.3 8.3 16.5 16.6 12.1l46.9-24.7 46.9 24.7c8.4 4.4 18.3-2.7 16.6-12.1l-9-52.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/medal.js
// module id = 1556
// module chunks = 0